import { configureStore } from "@reduxjs/toolkit";
import registrationReducer from "./registrationSlice";
import projectsReducer from "./projectsSlice";

export const store = configureStore({
  reducer: {
    registration: registrationReducer,
    projects: projectsReducer,
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
